<template>
    <div class="orderDetailContent">
        <!-- 面包屑 -->
        <div class="orderCrumbs">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '?type=order' }">我的订单</el-breadcrumb-item>
                <el-breadcrumb-item>订单详情</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="status">当前订单状态：<span>{{orderDetailData.status_zh}}</span></div>
        <div class="orderHead">订单信息</div>
        <div class="detailBox">
            <div class="detailText">订单类型：　　{{orderDetailData.type}}</div>
            <div class="detailText">订单编号：　　{{orderDetailData.order_num}}</div>
            <div class="detailText">订单提交：　　{{orderDetailData.create_time}}</div>
            <div class="align" @click="getGoodsDetail(orderDetailData.url)">
                <div class="detailText">提&nbsp; 供&nbsp; 方：　　</div>
                <div class="align" style="cursor: pointer;">
                    <el-image :src="require('@/assets/icon/orderLogo.png')" fit="cover" class="orderLogo"></el-image>
                    <div class="detailText" style="padding: 12px 7px;">{{orderDetailData.provide}}</div>
                    <el-image :src="require('@/assets/icon/nextGrey.png')" fit="cover" class="orderNext"></el-image>
                </div>
            </div>
        </div>
        <div class="detailTr align">
            <div style="width: 10%">商品</div>
            <div style="width: 22.5%">名称</div>
            <div style="width: 19.5%">发货交付信息</div>
            <div style="width: 16%">规格</div>
            <div style="width: 16%">价格</div>
        </div>
        <div class="detailTh align">
            <div style="width: 10%">
                <el-image :src="orderDetailData.goods_img" fit="cover" class="detailImg"></el-image>
            </div>
            <div style="width: 22.5%" class="center">
                <div class="detailTd">{{orderDetailData.goods_name}}</div>
            </div>
            <div style="width: 19.5%" class="center">
                <div class="detailTd orange">{{orderDetailData.information == '' ? '暂无交付信息' : orderDetailData.information}}</div>
            </div>
            <div style="width: 16%" class="center">
                <div class="detailTd">{{orderDetailData.spec_name}}</div>
            </div>
            <div style="width: 16%" class="center">
                <div class="detailTd"> 实付款￥{{orderDetailData.total_price}}</div>
            </div>
            <div style="width: 16%;cursor: pointer;" class="center" @click="contactTap">
                <el-image :src="require('@/assets/icon/my04.png')" fit="cover" class="detailContact"></el-image>
                <div class="detailTd orange">联系客服</div>
            </div>
        </div>
    </div>
</template>
<script>
    export default{
        data(){
            return{
                orderDetailData: {}
            }
        },
        created(){
            this.getOrderDetail()
        },
        methods: {
            // 获取订单详情
            getOrderDetail(){
                this.request.get("index/user/orderDetail",{
                    params:{
                        order_num: this.$route.query.id,
                        dif: 1
                    }
                })
                .then(res=>{
                    this.orderDetailData = res.data
                })
            },
            // 跳转商品详情
            getGoodsDetail(e){
                this.$router.push({ path: e })
            },
            // 跳转客服
            contactTap(){
                this.$router.push({ query:{type: 'contact'} })
            }
        }
    }
</script>
<style lang="less" scoped>
    .orderDetailContent{
        width: 100%;
        .orderCrumbs{
            width: 100%;
            padding: 20px 0;
            margin: 0 auto;
            font: 14px/14px "Microsoft YaHei";
        }
        .status{
            padding: 0 36px;
            height: 106px;
            background: #FAFAFA;
            font: 18px/106px "Microsoft YaHei";
            color: #606263;
            span{
                color: #FF6A00;
            }
        }
        .orderHead{
            margin: 28px 0 18px 0;
            padding: 0 10px;
            border-left: 2px solid #FF6A00;
            font: 14px/15px "Microsoft YaHei";
            color: #606263;
        }
        .detailBox{
            padding: 10px 16px;
            border-top: 1px solid #EFF1F5;
            .detailText{
                font: 14px/14px "Microsoft YaHei";
                color: #606263;
                padding: 12px 0;
            }
            .orderLogo{
                width: 19px;
                height: 17px;
            }
            .orderNext{
                width: 6px;
                height: 12px;
            }
        }
        .detailTr{
            width: 100%;
            height: 30px;
            background: #FAFAFA;
            font: 14px/30px "Microsoft YaHei";
            color: #606263;
            text-align: center;
            margin-top: 20px;
        }
        .detailTh{
            width: 100%;
            padding: 20px 0;
            .detailTd{
                padding: 0 8px;
                font: 14px/26px "Microsoft YaHei";
                color: #606263;
                word-break: break-all;
            }
            .detailImg{
                width: 62px;
                height: 62px;
                border-radius: 3px;
                margin: 0 20px;
            }
            .detailContact{
                width: 20px;
                height: 20px;
            }
            .orange{
                color: #FF6A00;
            }
        }
    }
</style>